import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function PaymentReminderViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_PAYMENT_REMINDER_XML_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <PaymentReminderViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <PaymentReminderViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const PaymentReminderViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const PaymentReminderViewBody = ({ header, body }: IModalProps) => {
  return <pre>{body}</pre>;
};
